(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window) || motion.matches) return;
  const reveal = (section) => section.classList.add('bv-soft-revealed');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) return;
      reveal(target);
      observer.unobserve(target);
    });
  }, { rootMargin: '0px 0px 40px 0px', threshold: 0 });
  const init = () => {
    document.querySelectorAll('#MainContent > .shopify-section').forEach((section) => {
      // Dawn already manages its own reveal elements. Keep initial content visible.
      if (section.classList.contains('bv-soft-reveal') || section.querySelector('.scroll-trigger')) return;
      const bounds = section.getBoundingClientRect();
      if (bounds.top < window.innerHeight || !bounds.height) return;
      section.classList.add('bv-soft-reveal');
      section.addEventListener('focusin', () => reveal(section), { once: true });
      observer.observe(section);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  motion.addEventListener('change', ({ matches }) => {
    if (!matches) return;
    document.querySelectorAll('.bv-soft-reveal').forEach(reveal);
    observer.disconnect();
  });
})();
